import React from 'react';

import { Button } from '@eika/button';
import { WarningCard } from '@eika/card';

import useTranslation from '../../../../../hooks/useTranslation';

interface Props {
    okButton?: () => void;
}

export const SettingsAccountOrderNeedMoreAccounts: React.FC<Props> = ({ okButton }) => {
    const translated = useTranslation();
    return (
        <WarningCard isModal title={translated.settingsAccountOrderNeedMoreAccounts}>
            <Button onClick={okButton} style={{ marginTop: '24px' }}>
                {translated.ok}
            </Button>
        </WarningCard>
    );
};
